/*
 * VTee PDP 追従カートバー
 *
 * 仕様:
 *   - 元カートボタン (.product-form__buttons) が viewport より下にある時のみ sticky を表示
 *   - 元ボタンに到達 or 通過したら sticky 非表示
 *
 * パフォーマンス:
 *   - scroll は passive listener
 *   - 表示判定は requestAnimationFrame でスロットリング (毎フレーム最大 1 回)
 *   - クラス操作も結果が変わった時のみ実行 (DOM 触る回数を最小化)
 *
 * これにより CSS の cubic-bezier transition がジャンク無くスムーズに動く。
 */
(function () {
  'use strict';

  function init() {
    var sticky = document.querySelector('[data-vtee-sticky-cart]');
    var target = document.querySelector('.product-form__buttons');
    if (!sticky || !target) return;

    var ticking = false;
    var lastVisible = null;

    function compute() {
      ticking = false;
      var targetRect = target.getBoundingClientRect();
      // 元ボタンが viewport の底より下にある = まだ到達していない → 表示
      // 少しヒステリシス気味に 8px のバッファを入れ、境界でチカチカしないように
      var shouldShow = targetRect.top > window.innerHeight - 8;

      if (shouldShow === lastVisible) return;
      lastVisible = shouldShow;

      sticky.classList.toggle('is-visible', shouldShow);
      sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(compute);
    }

    compute();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
